<template>
<div>
  <section class="speakers">
    <div class="container">
      <com-h1 class="light" title="100余位国内外技术专家"></com-h1>
      <com-speakers :speakers="speakers" status="dark"></com-speakers>
      <div class="box-button">
        <router-link to="/speaker"><c-button class="light">查看更多</c-button></router-link>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import CButton from 'gkConUI/com-button'
import ComSpeakers from 'gkConUI/com-speakers'

export default {
  components: {
    ComH1,
    CButton,
    ComSpeakers
  },
  props: ['speakers'],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.speakers
  padding: 47px 0
  background-color: $primary
</style>
